<template>
	<div id="dashboard" class="container-fluid px-0">
		<section id="seccionCabecera" class="w-100">
			<!-- Titulo y generador de informes -->
			<p class="ps-lg-4 mb-4">
				<span class="fas fa-trash fa-lg icon-hover-grow pt-2"></span>
				<span id="cabeceraDashboard" class="text-dark mb-0 h3 pl-2">Papelera de Reciclaje</span>
			</p>
		</section>
		<!-- Gráficas -->
		<section id="fila_carteras" class="row">
			<div class="col-12 mb-5">
				<div v-if="noData">
					<problemas-al-cargar/>
				</div>
				<div v-else-if="emptyBin">
					<no-hay-incidencias :textoFromPapelera="text" />
				</div>
				<div v-else>
					<table id="no-more-tables" class="table table-striped table-hover text-dark">
						<thead>
						<th v-if="this.$store.state.editar">Recuperar Incidencia</th>
						<th>ID incidencia</th>
						<th>Severidad</th>
						<th>Dominio</th>
						<th>Estado</th>
						<th>Descripcion</th>
						</thead>
						<tbody>
						<tr v-for="(item,index) of trashbin" v-bind:key="index" class="trashbin-tabla">
							<!-- ========================= Submenu de edicion ========================= -->
							<td v-if="this.$store.state.editar" class="cursor-pointer">
                                    <span>
                                        <img alt="" height="18" src="../assets/recoverIcon.png" width="18"
											 v-on:click="toggleRecoveryModal(index)">
                                    </span>
							</td>
							<!-- ========================= Incidencias ========================= -->
							
							<td class="auto-width-ticket">{{ item.TTNumberToDisplay }}</td>
							<td class="auto-width-severity">{{ item.severity }}</td>
							<td class="">{{ item.dominio }}</td>
							<td class="">{{ item.status }}</td>
							<td class="auto-height">{{ item.description }}</td>
						</tr>
						</tbody>
					</table>
					<BModal v-model="recoveryModal"
							title="Confirmación de recuperacion de incidencia"
							@ok="recover(recoverItem.TTNumber)"
					>
						¿Estás seguro de que quieres recuperar esta incidencia?
						{{ recoverItem.TTNumberToDisplay }}
					</BModal>
				</div>
			
			</div>
		</section>
	
	</div>

</template>


<script>
import auth from '../auth.js';
import ProblemasAlCargar from './ProblemasAlCargar.vue';
import NoHayIncidencias from './NoHayIncidencias.vue';

export default {
	data() {
		return {
			trashbin: [],
			noData: false,
			emptyBin: false,
			recoveryModal: false,
			recoverItem: { TTNumber: null, TTNumberToDisplay: null},
			text: "No hay incidencias en la papelera de reciclaje"
		}
	},
	components: {
		ProblemasAlCargar: ProblemasAlCargar,
		NoHayIncidencias: NoHayIncidencias
	},
	created() {
		this.consultarAlarmas();
		this.$store.state.botonEditar = true;
	},
	mounted() {
	},
	methods: {
		// Este deberia recuperar en vez de borrar
		toggleRecoveryModal(index) {
			// Activamos el modal de borrar mediante la variable recoveryModal
			// El BModal tiene una variable en el v-model
			// this.indexBorrado = index;
			// Capturo el número de TT para mostrarlo por pantalla y enviarlo al método
			// this.recoverItem = this.conjuntoAlarmas[this.indexBorrado].TTNumber;
			// Esta es la variable que activa el modalo. El Bmodal se encarga de ponerlo a False cuando
			// activas el cancel y el ok
			this.recoverItem.TTNumber = this.trashbin[index].TTNumber;
			this.recoverItem.TTNumberToDisplay = this.trashbin[index].TTNumberToDisplay;
			this.recoveryModal = true;
		},
		async consultarAlarmas() {
			if (!(this.$store.state.editar)) {
				try {
					const response = await fetch('api/bin/', {
						method: 'GET',
						headers: auth.getAuthHeader()
					})
					const data = await response.json()
					if (response.status === 401) { // En caso de que haya algún problema con el token, por ejemplo, ha caducado, desactivamos temporizador de actualizar alarmas y enviamos de nuevo a página de login.
						if (this.intervalo) {
							clearInterval(this.intervalo);
							this.intervalo = null; // Opcional: limpiar la referencia
						}
						localStorage.clear();
						this.$router.push({name: "login"})
							.catch(error => {
							});
					} else {
						if (data.length === undefined) {
							this.noData = true;
						} else if (data.length === 0) {
							this.emptyBin = true;
						} else {
							this.noData = false;
							this.emptyBin = false;
							this.trashbin = [];
							this.trashbin = data.map((item) => {
								return {
									dominio: item.Dominio === 'Red/Huawei' ? 'Red' : item.Dominio,
									TTNumber: item.TTNumber,
									TTNumberToDisplay: item.TTNumberToDisplay,
									status: item.Status,
									description: item.Description,
									severity: item.Severity
								}
							})
						}
					}
				} catch (error) {
					console.error('Error al realizar la consulta de alarmas', error);
				} finally {
					console.log(this.trashbin)
				}
			}
		},
		async recover(TTNumber) {
			this.editableIndex = null;
			try {
				const response = await fetch('/api/restoreAlarm/', {
					method: 'PUT',
					headers: auth.getAuthHeader(),
					body: JSON.stringify({TTNumber: TTNumber}
					)
				});
				const data = await response.json();
				this.$store.state.editar = false;
				this.consultarAlarmas();
			} catch (error) {
				console.error("No se pudieron borrar las comunicaciones de la incidencia " + TTNumber + ":", error);
			}
		},
		formatearFecha(date) {
			const formatter = new Intl.DateTimeFormat('es-ES', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: false,
				
			});
			
			return formatter.format(date).replace(',', '').replaceAll('/', '-');
		}
	}
}
</script>